export default "__VITE_ASSET__DYH1iQTn__"